import { SyncPortError } from '../../shared/errors.js';

export class ClipboardUnavailableError extends SyncPortError {}

/**
 * Copies the input's value by selecting it and issuing the legacy copy command.
 * Works on plain-HTTP origins where the async clipboard API is not exposed.
 */
const copyViaSelection = (input: HTMLInputElement): void => {
  const wasReadOnly = input.readOnly;
  input.readOnly = false;
  input.focus();
  input.select();
  input.setSelectionRange(0, input.value.length);
  const copied = document.execCommand('copy');
  input.readOnly = wasReadOnly;
  input.blur();
  if (!copied) {
    throw new ClipboardUnavailableError('Copy command was refused by the browser');
  }
};

/** Copies the input's value, preferring the async clipboard API and falling back to selection copy. */
export const copyInputValue = async (input: HTMLInputElement): Promise<void> => {
  if (typeof navigator.clipboard?.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(input.value);
      return;
    } catch {
      // The API exists but refused (for example the document lost focus); use the selection path.
    }
  }
  copyViaSelection(input);
};
